import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateKanbanPageAction } from '../actions/updateKanbanPage.action';
import { KanbanPage } from '../interfaces/kanbanPage.interface';

export const useUpdateKanbanPage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ pageId, updates }: { pageId: string; updates: Partial<KanbanPage> }) =>
      updateKanbanPageAction(pageId, updates),
    onSuccess: () => {
      // Invalidate and refetch kanban pages
      queryClient.invalidateQueries({
        queryKey: ['kanban-pages'],
      });
    },
  });
};

